/* AELA (26 Oct 2026): Shop all lashes grid, Lash Rehab style.
   Puts the page title tile in the first square of the product grid and gives every product two buttons:
   SUBSCRIBE & SAVE (the AELA Ritual, first delivery option) and ADD TO CART (one-off).
   Products without a Ritual option only get ADD TO CART. Both add to the cart drawer without leaving the page. */
(function () {
  var cache = {};
  function money(c) { return '$' + (c / 100).toFixed(2); }

  function addTitle(pl) {
    if (pl.querySelector('.aela-titletile')) return;
    var tpl = document.getElementById('aela-titletile-tpl');
    if (!tpl) return;
    var d = document.createElement('div');
    d.className = 'aela-titletile';
    d.innerHTML = tpl.innerHTML;
    pl.insertBefore(d, pl.firstChild);
  }

  function addButtons(card) {
    if (card.querySelector('.aela-btns')) return;
    var h = card.getAttribute('handle');
    if (!h) return;
    var box = document.createElement('div');
    box.className = 'aela-btns';
    card.appendChild(box);
    (cache[h] || (cache[h] = fetch('/products/' + h + '.js').then(function (r) { return r.json(); })))
      .then(function (p) {
        var v = p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
        var html = '';
        var a = v.selling_plan_allocations && v.selling_plan_allocations[0];
        if (a && v.available) {
          var pct = Math.round(100 - (a.price / v.price) * 100);
          html += '<button type="button" class="aela-b1" data-id="' + v.id + '" data-plan="' + a.selling_plan_id + '"><span>SUBSCRIBE &amp; SAVE ' + pct + '%</span><b>' + money(a.price) + '</b></button>';
        }
        html += '<button type="button" class="aela-b2" data-id="' + v.id + '"' + (v.available ? '' : ' disabled') + '><span>' + (v.available ? 'ADD TO CART' : 'SOLD OUT') + '</span><b>' + money(v.price) + '</b></button>';
        box.innerHTML = html;
      })
      .catch(function () {});
  }


  /* Centre every product photo: find the box and tray in the photo, then frame them in the middle of the square
     with the same breathing room on every card. Wide crops get soft edges that blend into the photo backdrop. */
  function fitImage(img) {
    if (img.dataset.aelaFit) return;
    var src = img.currentSrc || img.src;
    if (!src || !img.complete) { img.addEventListener('load', function () { fitImage(img); }, { once: true }); return; }
    img.dataset.aelaFit = '1';
    var im = new Image();
    im.crossOrigin = 'anonymous';
    im.onload = function () {
      try {
        var W = im.naturalWidth, H = im.naturalHeight, cv = document.createElement('canvas');
        cv.width = W; cv.height = H;
        var x = cv.getContext('2d'); x.drawImage(im, 0, 0);
        var d = x.getImageData(0, 0, W, H).data, x0 = W, y0 = H, x1 = 0, y1 = 0;
        for (var y = 0; y < H; y += 2) for (var xx = 0; xx < W; xx += 2) {
          var k = (y * W + xx) * 4, r = d[k], g = d[k + 1], b = d[k + 2];
          var l = (r + g + b) / 3, sa = Math.max(r, g, b) - Math.min(r, g, b);
          if (l < 120 || (sa > 28 && r > g + 15)) { if (xx < x0) x0 = xx; if (xx > x1) x1 = xx; if (y < y0) y0 = y; if (y > y1) y1 = y; }
        }
        if (x1 <= x0 || y1 <= y0) return;
        var side = Math.min(Math.max((x1 - x0) * 2.95, (y1 - y0) * 1.1), H);
        var cx = (x0 + x1) / 2, cy = Math.max(side / 2, Math.min(H - side / 2, (y0 + y1) / 2));
        var top = cy - side / 2, stops = [];
        for (var i = 0; i <= 8; i++) {
          var yy = Math.min(H - 1, Math.round(i * (H - 1) / 8)), rr = 0, gg = 0, bb = 0, n = 0;
          for (var dx = 0; dx < 4; dx++) [dx, W - 1 - dx].forEach(function (px) { var q = (yy * W + px) * 4; rr += d[q]; gg += d[q + 1]; bb += d[q + 2]; n++; });
          stops.push('rgb(' + Math.round(rr / n) + ',' + Math.round(gg / n) + ',' + Math.round(bb / n) + ') ' + ((yy - top) / side * 100).toFixed(1) + '%');
        }
        var box = img.closest('.product-card__media') || img.parentElement;
        box.style.background = 'linear-gradient(180deg,' + stops.join(',') + ')';
        img.style.width = (W / side * 100) + '%';
        img.style.left = (-(cx - side / 2) / side * 100) + '%';
        img.style.top = (-top / side * 100) + '%';
        img.classList.add('aela-fit');
        if (W / side < 0.995) img.classList.add('aela-band');
      } catch (e) {}
    };
    im.onerror = function () { img.dataset.aelaFit = ''; };
    im.src = src.replace(/([?&])width=\d+/, '$1width=420') + (src.indexOf('?') > -1 ? '&' : '?') + 'aelafit=2';
  }

  function run() {
    var pl = document.querySelector('product-list');
    if (!pl) return;
    addTitle(pl);
    pl.querySelectorAll('product-card').forEach(addButtons);
    pl.querySelectorAll('product-card img.product-card__image--primary').forEach(fitImage);
  }

  document.addEventListener('click', function (e) {
    var f = e.target.closest('.aela-titletile__filter');
    if (f) {
      var b = document.querySelector('.collection-toolbar [aria-controls="facets-drawer"]');
      if (b) b.click();
      return;
    }
    var btn = e.target.closest('.aela-btns button');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var label = btn.querySelector('span');
    var old = label.textContent;
    btn.disabled = true;
    label.textContent = 'ADDING...';
    var item = { id: Number(btn.dataset.id), quantity: 1 };
    if (btn.dataset.plan) item.selling_plan = Number(btn.dataset.plan);
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [item] }) })
      .then(function (r) { if (!r.ok) throw r; return fetch('/cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        setTimeout(function () { var cd = document.querySelector('cart-drawer'); if (cd && cd.show) cd.show(); }, 500);
        label.textContent = 'ADDED';
        setTimeout(function () { label.textContent = old; btn.disabled = false; }, 1600);
      })
      .catch(function () { label.textContent = old; btn.disabled = false; });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  new MutationObserver(function () { clearTimeout(window.__aelaShopAllT); window.__aelaShopAllT = setTimeout(run, 120); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();
